module.exports = __webpack_public_path__ + "img/man-with-shares.4a73bd6f.webp";